export const educationData = [
    {
        id: 1,
        institution: 'Masai School',
        course: 'Full Stack Web Development',
        startYear: '2021',
        endYear: '2022'
    },
    {
        id: 2,
        institution: 'Vedanta College of Management and Information Technology',
        course: 'Bachelor of Computer Science',
        startYear: '2014',
        endYear: '2017'
    },
    {
        id: 3,
        institution: 'New English High School and Jr. College',
        course: 'HSC',
        startYear: '2012',
        endYear: '2014'
    },
]